export const STORAGE_KEYS = {
  AUTH_STATUS: 'pdxAuthStatus',
  CURRENT_STEP: 'pdxCurrentStep',
  DATA: 'pdxData',
  LOGIN_EMAIL: 'pdxLoginEmail',
  ORDER_NUMBER: 'pdxOrderNumber',
  THEME: 'pdxTheme',
  AUTH_TOKEN: 'pdxAuthToken',
} as const;

export const QUERIES = {
  GET_ORDER: 'getOrder',
  GET_CART: 'getCart',
  GET_RESOLUTION_OPTIONS: 'getResolutionOptions',
  GET_DELIVERY: 'getDelivery',
  GET_REFUND_OPTIONS: 'getRefundOptions',
  GET_RETAILER_SETTINGS: 'getRetailerSettings',
  GET_CLAIM: 'getClaim',
};

export const MUTATIONS = {
  SUBMIT: 'submit',
};
